/**
 * Article Sticky Product Widget
 * Shows after scrolling 30% of article body.
 * Dismissible per session via sessionStorage.
 */
(function () {
  'use strict';

  var SHOW_THRESHOLD = 0.3;

  function init() {
    var desktopWidget = document.querySelector('.article-sticky-product--desktop');
    var mobileBar = document.querySelector('.article-sticky-bar');
    var articleBody = document.querySelector('.main-article__body');

    if (!desktopWidget && !mobileBar) return;
    if (!articleBody) return;

    var articleId = (desktopWidget || mobileBar).dataset.articleId;
    var dismissKey = 'sticky-product-dismissed-' + articleId;

    if (sessionStorage.getItem(dismissKey)) {
      if (desktopWidget) desktopWidget.style.display = 'none';
      if (mobileBar) mobileBar.style.display = 'none';
      return;
    }

    var shown = false;

    function showWidgets() {
      if (shown) return;
      shown = true;
      if (desktopWidget) desktopWidget.classList.add('is-visible');
      if (mobileBar) mobileBar.classList.add('is-visible');
      window.removeEventListener('scroll', onScroll);
    }

    function dismissAll() {
      sessionStorage.setItem(dismissKey, '1');
      if (desktopWidget) {
        desktopWidget.classList.remove('is-visible');
        setTimeout(function () { desktopWidget.style.display = 'none'; }, 300);
      }
      if (mobileBar) {
        mobileBar.classList.remove('is-visible');
        setTimeout(function () { mobileBar.style.display = 'none'; }, 300);
      }
    }

    function onScroll() {
      var rect = articleBody.getBoundingClientRect();
      if (rect.height === 0) return;
      var scrolled = -rect.top / rect.height;
      if (scrolled >= SHOW_THRESHOLD) {
        showWidgets();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // Close buttons
    if (desktopWidget) {
      var desktopClose = desktopWidget.querySelector('.article-sticky-product__close');
      if (desktopClose) desktopClose.addEventListener('click', dismissAll);
    }
    if (mobileBar) {
      var mobileClose = mobileBar.querySelector('.article-sticky-bar__close');
      if (mobileClose) mobileClose.addEventListener('click', dismissAll);
    }

    // Add to Cart
    function handleAddToCart(e) {
      e.preventDefault();
      var btn = e.currentTarget;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      var originalText = btn.textContent.trim();
      btn.textContent = 'Adding...';
      btn.style.pointerEvents = 'none';

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = originalText; btn.style.pointerEvents = ''; }, 2000);
          return;
        }
        btn.textContent = 'Added!';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-product', productVariantId: variantId, cartData: response });
        }
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { detail: { response: response }, bubbles: true }));
        setTimeout(function () { btn.textContent = originalText; btn.style.pointerEvents = ''; }, 2500);
      })
      .catch(function () { btn.textContent = originalText; btn.style.pointerEvents = ''; });
    }

    document.querySelectorAll('.article-sticky-product__atc[data-variant-id], .article-sticky-bar__atc[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', handleAddToCart);
    });
  }

  // Ensure DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
